import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { currentTimestamp } from '@utils/time';
import { attemptRefresh, getCustomerToken } from '@utils/userTokens';
import useSWR from 'swr';

const getTimeToExp = (exp: number) => (exp - currentTimestamp()) * 1000 - 60;
const fetcher = async (): Promise<{
  idToken?: string | null;
  refreshToken?: string | null;
  exp?: number;
}> => {
  const { idToken, refreshToken, exp, expired } = getCustomerToken();

  if (!idToken) {
    return {};
  }
  if (!expired) {
    return { idToken, refreshToken, exp: getTimeToExp(exp) };
  }

  const session = await attemptRefresh(refreshToken);
  if (!session) {
    return {};
  }
  return {
    idToken: session.idToken,
    exp: getTimeToExp(session.expiresIn),
    refreshToken,
  };
};

const getFallbackData = (accountsEnabled: boolean) => {
  if (!accountsEnabled) {
    return {};
  }
  const tokens = getCustomerToken();
  return tokens.expired ? {} : tokens;
};

export const useCustomerTokens = () => {
  const { accountsEnabled } = useCurrentUrl();
  return useSWR(accountsEnabled ? 'customerTokens' : null, fetcher, {
    refreshWhenHidden: true,
    keepPreviousData: true,
    refreshInterval: (data) => data?.exp ?? 0,
    fallbackData: getFallbackData(accountsEnabled),
  });
};
